import { FormikErrors } from 'formik'

import { MAX_VEHICLES_INSURED } from '../../_utils/environmentConst.provider'
import {
  biggerThanZero,
  lowerOrEqualThan,
  onlyNumber,
  required,
  validVehiclePlate,
} from '../../_utils/formValidators'
import { VehiclesInfoValues } from './Vehicles.view'

const validateNumberOfVehiclesAboveZero = biggerThanZero(
  'step1.numberOfVehicles.validateBiggerThanZero',
)

const validateVehiclesToEnsureInRange = biggerThanZero(
  'step1.vehiclesToEnsure.validateBiggerThanZero',
)

const validateVehiclesLessThanAvailable = lowerOrEqualThan(
  'step1.vehiclesToEnsure.validateLessThanAvailable',
)

const validateVehiclesLessThanMaximum = lowerOrEqualThan(
  'step1.vehiclesToEnsure.validateLessThanMaximum',
)

const validateNumberOfVehicles = (numberOfVehicles: number) => {
  return (
    onlyNumber.default(numberOfVehicles) ||
    validateNumberOfVehiclesAboveZero(numberOfVehicles)
  )
}

const validateVehiclesToEnsure = (
  vehiclesToEnsure: number,
  numberOfVehicles: number,
) => {
  return (
    onlyNumber.default(vehiclesToEnsure) ||
    validateVehiclesToEnsureInRange(vehiclesToEnsure) ||
    validateVehiclesLessThanAvailable(vehiclesToEnsure, numberOfVehicles) ||
    validateVehiclesLessThanMaximum(vehiclesToEnsure, MAX_VEHICLES_INSURED)
  )
}

const validateVehiclePlate = (vehiclePlate: string) => {
  return (
    required.default(vehiclePlate) || validVehiclePlate.default(vehiclePlate)
  )
}

export const validateFieldForm = (formValueFields: VehiclesInfoValues) => {
  const errors: FormikErrors<VehiclesInfoValues> = {}

  if (validateNumberOfVehicles(formValueFields.numberOfVehicles)) {
    errors.numberOfVehicles = validateNumberOfVehicles(
      formValueFields.numberOfVehicles,
    )
  }

  if (
    validateVehiclesToEnsure(
      formValueFields.vehiclesToEnsure,
      formValueFields.numberOfVehicles,
    )
  ) {
    errors.vehiclesToEnsure = validateVehiclesToEnsure(
      formValueFields.vehiclesToEnsure,
      formValueFields.numberOfVehicles,
    )
  }

  formValueFields.plates.map((plate, i) => {
    if (validateVehiclePlate(plate))
      errors[`plate${i + 1}`] = validateVehiclePlate(plate)
  })

  return errors
}
